__turbopack_context__.v({
  "productTop": "product-page-header-module-scss-module__sypADa__productTop",
  "productTopButtonPanel": "product-page-header-module-scss-module__sypADa__productTopButtonPanel",
  "productTopCodeItem": "product-page-header-module-scss-module__sypADa__productTopCodeItem",
  "productTopCodePanel": "product-page-header-module-scss-module__sypADa__productTopCodePanel",
  "productTopMobileRating": "product-page-header-module-scss-module__sypADa__productTopMobileRating",
  "productTopMobileServiceLine": "product-page-header-module-scss-module__sypADa__productTopMobileServiceLine",
  "productTopProductButtonList": "product-page-header-module-scss-module__sypADa__productTopProductButtonList",
  "productTopPromotions": "product-page-header-module-scss-module__sypADa__productTopPromotions",
  "productTopServiceRow": "product-page-header-module-scss-module__sypADa__productTopServiceRow",
  "productTopTitle": "product-page-header-module-scss-module__sypADa__productTopTitle",
});
